import { useState } from 'react';

export interface UseComparisonTableStateProps {
  syncLegendComparisonTable?: boolean; // Sync Abs/% toggle across sections (default: true)
}

export interface UseComparisonTableStateReturn {
  // Global state (used when syncLegendComparisonTable=true)
  showPercentage: boolean;
  setShowPercentage: React.Dispatch<React.SetStateAction<boolean>>;
  showTableView: boolean;
  setShowTableView: React.Dispatch<React.SetStateAction<boolean>>;
  // Per-section state (used when syncLegendComparisonTable=false)
  showPercentageBySection: Record<string, boolean>;
  setShowPercentageBySection: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  showTableViewBySection: Record<string, boolean>;
  setShowTableViewBySection: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}

/**
 * Manages comparison table state (percentage/table view toggles)
 * Supports both synced (global) and per-section modes
 */
export function useComparisonTableState({
  syncLegendComparisonTable = true,
}: UseComparisonTableStateProps = {}): UseComparisonTableStateReturn {
  // Track show percentage - synced across all sections when syncLegendComparisonTable=true
  const [showPercentage, setShowPercentage] = useState<boolean>(true);

  // Track show percentage per section when syncLegendComparisonTable=false
  const [showPercentageBySection, setShowPercentageBySection] = useState<Record<string, boolean>>({});

  // Track show table view - synced across all sections when syncLegendComparisonTable=true
  const [showTableView, setShowTableView] = useState<boolean>(true);

  // Track show table view per section when syncLegendComparisonTable=false
  const [showTableViewBySection, setShowTableViewBySection] = useState<Record<string, boolean>>({});

  return {
    showPercentage,
    setShowPercentage,
    showTableView,
    setShowTableView,
    showPercentageBySection,
    setShowPercentageBySection,
    showTableViewBySection,
    setShowTableViewBySection,
  };
}
